// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--2TVUh","description":"Footer-module--description--2AouO","bottom":"Footer-module--bottom--34Hth"};